import { BrandApi } from '../openapi';
import { config } from './config';

export const BrandClient = new BrandApi(config);
